import { useState, useEffect, useRef, type FormEvent } from "react";
import { DraftSection } from "./DraftSection";
import { LogoutButton } from "./LogoutButton";
import { Button } from "./Button";

interface NotFoundViewProps {
  email: string;
  conversationId: string;
  onSearch: (email: string) => void;
}

export function NotFoundView({ email, conversationId, onSearch }: NotFoundViewProps) {
  const [searchEmail, setSearchEmail] = useState(email);
  const inputRef = useRef<HTMLInputElement>(null);
  const message = email
    ? `No customer found for ${email}`
    : "Search for a customer";

  useEffect(() => {
    setSearchEmail(email);
  }, [email]);

  useEffect(() => {
    if (!email) {
      inputRef.current?.focus();
    }
  }, [email]);

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (searchEmail.trim()) {
      onSearch(searchEmail.trim());
    }
  }

  return (
    <div className="flex min-h-[calc(100vh-32px)] flex-col">
      <div className="flex flex-1 flex-col justify-center gap-4">
        <p className="text-center text-sm text-(--text-muted,#6b7280)">{message}</p>
        <form className="mt-2" onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="search-email" className="mb-1 block text-sm font-medium">
              Search by email
            </label>
            <input
              ref={inputRef}
              type="email"
              id="search-email"
              name="search-email"
              placeholder="customer@example.com"
              value={searchEmail}
              onChange={(e) => setSearchEmail(e.target.value)}
              className="w-full rounded-md border border-(--border-color,#d1d5db) bg-(--input-background,#fff) px-3 py-2 text-sm text-(--text-color,#111) focus:border-(--accent-color,#3b82f6) focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
            />
          </div>
          <Button type="submit" fullWidth>
            Search
          </Button>
        </form>
      </div>
      {conversationId && <DraftSection conversationId={conversationId} />}
      <LogoutButton />
    </div>
  );
}
